<template>
  <pre v-if="responseData"> testData={{ responseTandas }}</pre>
  <div v-if="tandas">
    <div class="content-wrapper">
      <h2>PROGRAM PENARAFAN BINTANG</h2>
      <div class="input-row">
        <!-- <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div> -->

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPremis"
            label="Premis Kategori"
            :items="premis"
            placeholder="Pilih Kategori"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      <h2>Pengauditan dan Penarafan Bintang Tandas Awam di PBT</h2>
      <div class="main-image-container">
        <img src="@/assets/tandas/tandas.png" alt="First Image" />
        <div class="main-number-overlay">
          {{ tandas.jumlah_tandas_diaudit }}
        </div>
      </div>
      <div class="tandas">
        <div class="tandas-container">
          <img src="@/assets/tandas/five.png" alt="Second Image" />
          <div class="number-overlay">
            {{ tandas["5_bintang"] }}
          </div>
        </div>

        <div class="tandas-container">
          <img src="@/assets/tandas/four.png" alt="Third Image" />
          <div class="number-overlay">
            {{ tandas["4_bintang"] }}
          </div>
        </div>

        <div class="tandas-container">
          <img src="@/assets/tandas/three.png" alt="Fourth Image" />
          <div class="number-overlay">
            {{ tandas["3_bintang"] }}
          </div>
        </div>

        <div class="tandas-container">
          <img src="@/assets/tandas/two.png" alt="Fifth Image" />
          <div class="number-overlay">
            {{ tandas["2_bintang"] }}
          </div>
        </div>
      </div>
      <Update />
      <PrimaryModule />
      <KesihatanPersekitaran />
    </div>
  </div>
</template>

<script setup>
import { useHttpService } from "@/httpService";
import { onMounted, ref, watch, toRaw } from "vue";

definePage({
  alias: "/pages/pages/inspektorat/i-tegur",
  meta: {
    layout: "blank",
    public: true,
  },
});

const years = ref([]);
const states = ref(["Semua Negeri"]);
const pbt = ref([]);
const premis = ref([]);
const councils = ref([]);
const selectedYear = ref(2025);

const selectedsState = ref("Semua Negeri");
const selectedPbt = ref("Semua PBT");
const selectedPremis = ref(["Semua Premis"]);

const {
  loading,
  error,
  httpDelete,
  httpPostPut,
  httpGet,
  httpPost,
  numberWithCommas,
  formatToMillion,
} = useHttpService();

const responseTandasData = ref(null);
const tandas = ref(null);

const initialLoad = ref(true); // ✅ Flag to handle first-time load only

async function loadAvailableYears() {
  try {
    const response = await httpGet(
      "kesihatan-persekitaran/cegah-jangkit/program-awam-bersih"
    );

    const internalYears = (response?.years || []).filter((y) => y !== 2025);
    const allYears = [...new Set([...internalYears, 2025])].sort(
      (a, b) => b - a
    );
    years.value = allYears;
  } catch (err) {
    console.error("Failed to load available years:", err);
    years.value = [2025];
  }
}

async function loadDataFromApi(
  year = selectedYear.value,
  state = selectedsState.value,
  pbtValue = selectedPbt.value,
  premisValue = selectedPremis.value
) {
  try {
    const isExternalYear = year === 2025;

    if (isExternalYear) {
      const token = "17535|MqnzNqNSM3JpAH2k5QCxq21fNVhC9MZJZ7lVPte33cd13ffb";
      const response = await fetch(
        "https://mywc.kpkt.gov.my/api/integration/get-toilet-list",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      const data = await response.json();
      const toiletList = data.data || [];

      const selectedStates = (Array.isArray(state) ? state : [state]).map((s) =>
        s.toUpperCase()
      );
      const selectedPbts = (
        Array.isArray(pbtValue) ? pbtValue : [pbtValue]
      ).map((p) => p.toUpperCase());

      const filteredToilets = toiletList.filter((toilet) => {
        const stateMatch =
          selectedStates.includes("SEMUA NEGERI") ||
          selectedStates.includes(toilet.state?.toUpperCase());
        const pbtMatch =
          selectedPbts.includes("SEMUA PBT") ||
          selectedPbts.includes(toilet.service_area?.toUpperCase());
        return (
          stateMatch &&
          pbtMatch &&
          toilet.average_star != null &&
          toilet.average_star > 0
        );
      });

      const allowedCategories = [
        "Bangunan Kerajaan",
        "Hotel",
        "Tandas Awam PBT",
        "Terminal Pengangkutan Awam",
        "Bangunan-bangunan Komersial",
        "Hentian Sebelah / Kawasan R&R",
        "Pasar Awam",
        "Pintu Masuk Utama Negara",
        "Pusat Beli-belah",
        "IPTA / IPTS",
        "Pusat Peranginan / Pelancongan",
        "Restoran dan Premis Makanan",
        "Rumah Ibadat",
        "Sekolah",
        "Stesen Minyak",
        "Taman Rekreasi",
      ];

      const uniqueCategories = [
        ...new Set(
          filteredToilets
            .map((t) => t.premise_category)
            .filter((c) => c && allowedCategories.includes(c))
        ),
      ];

      if (initialLoad.value && premis.value.length <= 1) {
        premis.value = ["Semua Premis", ...uniqueCategories];
        selectedPremis.value = ["Semua Premis"];
        initialLoad.value = false;
      } else {
        const current = new Set(premis.value);
        const newPremis = ["Semua Premis", ...uniqueCategories];
        if (uniqueCategories.length > 0 && premis.value.length <= 1) {
          premis.value = newPremis;
        }
      }

      const selectedPremisList = Array.isArray(premisValue)
        ? premisValue
        : [premisValue];

      const filteredPremisToilets = filteredToilets.filter(
        (toilet) =>
          toilet.premise_category &&
          (selectedPremisList.includes("Semua Premis") ||
            selectedPremisList.includes(toilet.premise_category))
      );

      // 🛠 Group by category -> star -> Set of premise_name
      const grouped = {};
      filteredPremisToilets.forEach((toilet) => {
        const category = toilet.premise_category;
        const name = toilet.premise_name;
        const star = Math.round(toilet.average_star);

        if (!category || !name || ![2, 3, 4, 5].includes(star)) return;

        if (!grouped[category])
          grouped[category] = {
            "2_bintang": new Set(),
            "3_bintang": new Set(),
            "4_bintang": new Set(),
            "5_bintang": new Set(),
          };

        grouped[category][`${star}_bintang`].add(name);
      });

      // 🔢 Count totals per star level across all categories
      const totalCount = {
        "2_bintang": 0,
        "3_bintang": 0,
        "4_bintang": 0,
        "5_bintang": 0,
      };

      for (const starsMap of Object.values(grouped)) {
        for (const key of Object.keys(totalCount)) {
          totalCount[key] += starsMap[key]?.size || 0;
        }
      }

      tandas.value = {
        jumlah_tandas_diaudit:
          totalCount["2_bintang"] +
          totalCount["3_bintang"] +
          totalCount["4_bintang"] +
          totalCount["5_bintang"],
        ...totalCount,
      };

      // Set states and councils
      states.value = [
        "Semua Negeri",
        ...new Set(toiletList.map((t) => t.state).filter(Boolean)),
      ];

      const groupedCouncils = {};
      toiletList.forEach((toilet) => {
        const state = toilet.state;
        const pbt = toilet.service_area;
        if (state && pbt) {
          if (!groupedCouncils[state]) groupedCouncils[state] = {};
          groupedCouncils[state][pbt] = { value: pbt };
        }
      });
      councils.value = groupedCouncils;
    } else {
      // Internal year (2024 and earlier)
      const plainStates = toRaw(state);
      let queryParams = `year=${year}`;

      if (!plainStates.includes("Semua Negeri")) {
        (Array.isArray(plainStates) ? plainStates : [plainStates]).forEach(
          (s) => {
            const stateName = typeof s === "string" ? s : s.name || s.value;
            queryParams += `&states[]=${encodeURIComponent(stateName)}`;
          }
        );
      }

      if (Array.isArray(pbtValue) && !pbtValue.includes("Semua PBT")) {
        pbtValue.forEach((pbt) => {
          queryParams += `&councils[]=${encodeURIComponent(pbt)}`;
        });
      }

      const url = `kesihatan-persekitaran/cegah-jangkit/program-awam-bersih?${queryParams}`;
      const response = await httpGet(url);

      states.value = [
        "Semua Negeri",
        ...response.states.filter((s) => s && s !== "Modified Pbt"),
      ];
      councils.value = response.councils || {};
      responseTandasData.value = response;
      tandas.value = response?.categorical_data?.Semua || {};
    }
  } catch (err) {
    console.error("loadDataFromApi failed:", err);
  }
}

function handleStateChange() {
  pbt.value = [];

  if (!Array.isArray(selectedsState.value))
    selectedsState.value = [selectedsState.value];
  if (!Array.isArray(selectedPbt.value))
    selectedPbt.value = [selectedPbt.value];

  if (
    selectedsState.value.includes("Semua Negeri") &&
    selectedsState.value.length > 1
  ) {
    selectedsState.value = selectedsState.value.filter(
      (state) => state !== "Semua Negeri"
    );
  }
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter((pbt) => pbt !== "Semua PBT");
  }

  if (selectedsState.value.length === 0)
    selectedsState.value = ["Semua Negeri"];
  if (selectedPbt.value.length === 0) selectedPbt.value = ["Semua PBT"];

  if (selectedsState.value.includes("Semua Negeri")) {
    Object.keys(councils.value).forEach((state) => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach((councilKey) => {
          const council = councils.value[state][councilKey];
          if (council && council.value) pbt.value.push(council.value);
        });
      }
    });
  } else {
    selectedsState.value.forEach((state) => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach((councilKey) => {
          const council = councils.value[state][councilKey];
          if (council && council.value) pbt.value.push(council.value);
        });
      }
    });
  }
}

onMounted(() => {
  loadAvailableYears();
  loadDataFromApi();
});

watch([selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(
    selectedYear.value,
    selectedsState.value,
    selectedPbt.value,
    selectedPremis.value
  );
});

watch(
  councils,
  (newValue) => {
    if (newValue) handleStateChange();
  },
  { immediate: true }
);

watch(selectedPremis, (newVal) => {
  if (!Array.isArray(newVal) || newVal.length === 0) {
    selectedPremis.value = ["Semua Premis"];
    return;
  }

  // Remove "Semua Premis" if other options are selected
  if (newVal.includes("Semua Premis") && newVal.length > 1) {
    selectedPremis.value = newVal.filter((item) => item !== "Semua Premis");
    return;
  }

  loadDataFromApi(
    selectedYear.value,
    selectedsState.value,
    selectedPbt.value,
    selectedPremis.value
  );
});
</script>

<style scoped>
.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; /* Match width to the image size */
  margin-block-start: 10px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px; /* Rounded corners */
  background-color: rgba(255, 255, 255, 65%); /* Background for content */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%); /* Shadow for depth */
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1200px;
}

/* Flexbox container for the input fields */
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Styles for each input field */
.input-item {
  flex: 1;
  margin-right: 15px;
}

/* Remove margin for the last item */
.input-item:last-child {
  margin-right: 0;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: left;
  text-transform: uppercase;
}

.title-main {
  color: darkblue;
  font-size: 2rem;
  font-weight: bold;
  margin-block-end: 20;
  text-align: center;
}

.main-image-container {
  position: relative;
  display: inline-block;
}

.main-number-overlay {
  position: absolute;
  top: 85%; /* Adjusted to position number closer to the bottom */
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 3rem;
  font-weight: bold;
  color: #a80000;
  padding: 10px 20px;
  border-radius: 5px;
}

.tandas {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px; /* Reduced gap between the main and star rating images */
  margin-top: 10px; /* Adjusted margin for smaller space between main and tandas sections */
}

.tandas-container {
  position: relative;
  width: 100%;
  max-width: 450px; /* Adjust the size to fit 2 columns */
  margin: 0 auto;
  border-radius: 10px;
  overflow: hidden;
}

.tandas-container img {
  border-radius: 10px; /* Optional: Add rounded corners */
}

.number-overlay {
  position: absolute;
  top: 50%;
  left: 90%;
  transform: translate(-50%, -50%);
  font-size: 2rem;
  font-weight: bold;
  color: #a80000;
  padding: 10px;
  border-radius: 5px;
}
/* Responsive styles */
@media (max-width: 768px) {
  .content-wrapper {
    padding: 15px;
  }

  h2 {
    font-size: 1.3rem;
  }

  .main-number-overlay {
    font-size: 2.5rem;
  }

  .tandas {
    grid-template-columns: 1fr; /* Stack items in a single column on smaller screens */
  }

  .number-overlay {
    font-size: 1.8rem;
  }
}

@media (max-width: 480px) {
  h2 {
    font-size: 1.2rem;
  }

  .main-number-overlay {
    font-size: 2rem;
  }

  .number-overlay {
    font-size: 1.5rem;
  }
}
</style>
